import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Lebanon: Country = {
    identifier: "Lebanon",
    name: "Lebanon",
    countryCode: "LB",
    group: CountryGroup.ASIA,
    isUNMember: true,
    flag: "🇱🇧",
    svgPath: "m 575.56175,363.8614 -0.08,0.055 -0.149,0.153 -0.149,0.124 -0.301,0.193 -0.068,0.115 -0.067,-0.104 -0.131,0.071 -0.11,0.437 -0.23,0.146 -0.288,-0.013 -0.24,-0.041 -0.322,0.027 0.131,-0.254 0.136,-0.331 0.134,-0.446 0.237,-0.371 0.491,-1.264 0.284,-0.513 0.101,-0.73 0.439,-0.639 0.328,-0.19 0.159,-0.183 -0.004,-0.278 0.49,0.002 0.316,-0.014 0.091,-0.156 0.247,0.071 0.137,0.15 -0.124,0.159 -0.175,0.181 0.01,0.047 0.131,0.015 0.222,0.098 0.136,0.115 0.227,0.714 -0.14,0.293 -0.218,0.262 -0.097,0.023 -0.191,0.13 -0.16,0.178 -0.056,0.112 0.012,0.105 0.226,0.131 0.007,0.053 -0.047,0.042 -0.183,-0.029 -0.236,-0.014 -0.139,10e-4 -0.161,0.026 -0.206,0.16 -0.092,0.106 -0.049,0.068 -0.074,0.217 0.083,0.149 0.154,0.085 0.022,0.043 -0.035,0.075 -0.153,0.094 -0.115,0.115 -0.033,0.117 z",
}
